import { mapActions } from 'vuex';

/** Number of the unsaved project (ProjectEdit `_new`): the bank blocks need a saved project. */
const NEW_PROJECT_NUMBER = '_new';

/**
 * Shared part of the bank blocks (see feature page projekt-bank): the hint on the unsaved project
 * and the reload of the block after an operation. The component names its field on
 * `ProjectBlocks` and its fragment as the options `bankBlockField` and `bankBlockFragment`.
 */
export const ProjectBankBlockMixin = {
  computed: {
    isNewProject() {
      return this.project.number === NEW_PROJECT_NUMBER;
    },
  },
  methods: {
    ...mapActions(['fetchProjectBlockByNumber']),
    /** Reloads only this block; returns the block, or null when the reload failed. */
    reloadBlock() {
      return this.fetchProjectBlockByNumber({
        projectNumber: this.project.number,
        blockField: this.$options.bankBlockField,
        fragment: this.$options.bankBlockFragment,
      });
    },
  },
};
